// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__bxA1U","logo":"Sidebar_logo__wkJ8-","menu":"Sidebar_menu__VHcaT","item":"Sidebar_item__q4H0j"};